﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadAnnotationField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadAnnotationField, eOutputFieldType.cadAnnotation)
export class CadAnnotationField extends OutputField implements ICadAnnotationField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
    public markedForDrawing: boolean;
}
